module.exports = __webpack_public_path__ + "img/pin-pegawai.85561cb1.png";